import React from "react";
import { IconButton, Tooltip, useTheme } from "@mui/material";
import { Sparkles } from "lucide-react";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";

const V2_PREFIX = "/v2";

const V2ToggleCst: React.FC = () => {
  const theme = useTheme();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();

  const isV2 = location.pathname.startsWith(V2_PREFIX);

  const handleToggle = () => {
    const { pathname } = location;
    if (isV2) {
      navigate(pathname.replace(V2_PREFIX, "") || "/");
    } else {
      const normalized = pathname.startsWith("/") ? pathname : `/${pathname}`;
      navigate(`${V2_PREFIX}${normalized}`);
    }
  };

  return (
    <Tooltip
      title={
        isV2
          ? t("header.toggle-admin-v2.close")
          : t("header.toggle-admin-v2.open")
      }
    >
      <IconButton
        onClick={handleToggle}
        size="small"
        sx={{
          width: "36px",
          height: "36px",
          borderRadius: "8px",
          border: `1px solid ${
            isV2 ? theme.palette.primary.main : theme.palette.divider
          }`,
          color: isV2 ? theme.palette.primary.main : theme.palette.text.primary,
          "&:hover": {
            backgroundColor: theme.palette.action.hover,
            borderColor: theme.palette.primary.main,
          },
        }}
      >
        <Sparkles size={18} />
      </IconButton>
    </Tooltip>
  );
};

export default V2ToggleCst;
